import React, {Component} from 'react'
import {reduxForm, Field, formValueSelector} from 'redux-form'
import {connect} from 'react-redux'
import {NavLink} from 'react-router-dom'
import DatePickerFormComponent from '../components/redux-form/DatePickerFormComponent'
import CategoriesSelectFormComponent from '../components/redux-form/CategoriesSelectFormComponent'
import VirtualizedSelectFormComponent from '../components/redux-form/VirtualizedSelectFormComponent'
import './BackOfficeUserEditScreen.css'
import CategoriesTreeSelectFormComponent from '../components/redux-form/CategoriesTreeSelectFormComponent'

const mapStateToProps = (state) => {
  return {
    userFormValues: state.form.backofficeUserEdit
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch
  }
}

const checkObjectProp = (obj, props) => {
  let splited = props.split('.')
  let temp = obj
  for (let index in splited) {
    if (typeof temp[splited[index]] === 'undefined') return false
    temp = temp[splited[index]]
  }
  return true
}

const isResident = (categories) => {
  let filteredCategories = categories.filter(item => {
    return item.resident
  })

  return filteredCategories.length > 0
}

const isParkPlaceInDifferentAddress = (categories) => {
  let filteredCategories = categories.filter(item => {
    console.log(item)
    return item.parkingInDifferentPlace
  })

  return filteredCategories.length > 0
}

const isWorker = (categories) => {
  let filteredCategories = categories.filter(item => {
    return item.worker
  })

  return filteredCategories.length > 0
}

const isWorkerPerson = (categories) => {
  console.log(categories)
  let filteredCategories = categories.filter(item => {
    return item.workerPerson
  })

  return filteredCategories.length > 0
}

// crea utente
class BackOfficeUserEditScreen extends Component {
  constructor (props) {
    super(props)
    this.state = {
      deleteClicked: false
    }
  }

  render () {
    const {error, handleSubmit, loading} = this.props

    if (loading) {
      return (<div>Caricamento in corso...</div>)
    }

    return (<div className="col-md-12">
      <div className="panel panel-default panel-border">
        <div className="panel-body">
          <h2 className="title">Modifica Utente</h2>
          <div>
            {this.props.user && <NavLink exact className="btn btn-green" to={'/backoffice/users/' + this.props.user.id}>TORNA AL PROFILO</NavLink>}
          </div>
          <form onSubmit={handleSubmit}>
            <div className="box">
              {/* Inizio informazioni generali utente */}
              <fiedset>
                <div className="titolo-categoria">
                  <legend className="text-left">Informazioni generali</legend>
                </div>
                <div className="row">
                  <div className="col-md-6 text-left">
                    <label>Nome</label>
                    <Field component="input" name="firstName" type="text" className="resident-login" required />
                  </div>
                  <div className="col-md-6 text-left">
                    <label>Cognome</label>
                    <Field component="input" name="lastName" type="text" className="resident-login" required />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 text-left">
                    <label>E-mail</label>
                    <Field component="input" name="email" type="text" className="resident-login" />
                  </div>
                  <div className="col-md-6 text-left">
                    <label>Telefono Mobile</label>
                    <Field component="input" name="phone" type="text" placeholder="333 333 3333" className="resident-login" />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 text-left">
                    <label>Codice Fiscale</label>
                    <Field component="input" name="fiscalCode" type="text" className="resident-login" required />
                  </div>
                  <div className="col-md-6 text-left">
                    <label>Rigenera Credenziali</label><br />
                    <button onClick={() => this.props.onGenerateUserCredentials()} className="btn btn-default">Rigenera Password e Stampa Credenziali</button>
                  </div>
                </div>
              </fiedset>
              {/* Fine informazioni generali utente */}

              {/* Inizio Categorie Utente */}
              <div className="row">
                <div className="col-md-6 text-left">
                  <label>Seleziona Categorie Utente</label>
                  <Field
                    required
                    options={this.props.categoryOptions}
                    component={CategoriesTreeSelectFormComponent}
                    onCategoriesChange={(categories) => this.props.onCategoriesChange(categories)}
                    name="userCategories"
                    placeholder="Seleziona Categorie Utente" />
                </div>
              </div>
              {/* Fine Categorie Utente */}

              {/* Inizio Informazioni Residente */}
              {isResident(this.props.selectedCategories) &&
              <fiedset>
                <div className="titolo-categoria">
                  <legend className="text-left">Residente</legend>
                </div>
                <div>
                  <div className="row">
                    <div className="col-md-6 text-left">
                      <label>Data di Nascita</label>
                      <Field component={DatePickerFormComponent} name="birthDate" className="resident-login" required />
                    </div>
                    <div className="col-md-6 text-left">
                      <label>Città di Nascita</label>
                      <Field
                        name="birthPlace" options={this.props.comuni}
                        component={VirtualizedSelectFormComponent} required />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 text-left">
                      <label>Sesso</label><br />
                      <label className="sex">
                        <Field name="sex" component="input" type="radio" value="M" required /> {' '} Uomo
                      </label>
                      {' '}
                      <label>
                        <Field name="sex" component="input" type="radio" value="F" required /> {' '} Donna
                      </label>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 text-left">
                      <label>Seleziona Area di Residenza</label>
                      <Field name="residenceAreaId" className="form-control" component="select" required>
                        <option value={''}>Seleziona Area</option>
                        {this.props.areas.map(item =>
                          <option key={item.id} value={item.id}>{item.code + ' - ' + item.name}</option>)}
                      </Field>
                    </div>
                    <div className="col-md-4 text-left">
                      <label>Indirizzo di Residenza/Domicilio</label>
                      <Field
                        component="input"
                        name="residenceAddress"
                        type="text"
                        placeholder="Via X"
                        className="resident-login"
                        required />
                    </div>
                    <div className="col-md-2 text-left">
                      <label>N° Civico</label>
                      <Field
                        component="input"
                        name="residenceCivicNumber"
                        type="text" placeholder="N°"
                        className="resident-login"
                        required />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12 text-info text-left">
                      I campi a seguire sono da compilare solo nel caso l'indirizzo precedente rappresenti il domicilio
                    </div>
                    <div className="col-md-7 text-left">
                      <label>Indirizzo di Residenza</label>
                      <Field
                        component="input"
                        name="secondaryResidenceAddress"
                        type="text"
                        placeholder="Indirizzo di residenza"
                        className="resident-login"
                      />
                    </div>
                    <div className="col-md-3 text-left">
                      <label>Città</label>
                      <Field
                        name="secondaryResidenceCity"
                        options={this.props.comuniWithoutLodi}
                        component={VirtualizedSelectFormComponent}
                      />
                    </div>
                    <div className="col-md-2 text-left">
                      <label>CAP</label>
                      <Field
                        component="input"
                        name="secondaryResidenceCap"
                        type="text"
                        placeholder="CAP"
                        className="resident-login"
                      />
                    </div>
                  </div>

                  {isParkPlaceInDifferentAddress(this.props.selectedCategories) && (
                    <div className="row">
                      <div className="col-md-12 text-info text-left" style={{marginTop: 10, marginBottom: 10}}>
                        Questa categoria utente ha un posto auto in un luogo diverso da quello di residenza/domicilio
                      </div>
                      <div className="col-md-7 text-left">
                        <label>
                          Indirizzo del Posto Auto
                        </label>
                        <Field
                          onChange={(event, data) => this.props.onParkingSpaceAddressSelected(data)}
                          name="parkingSpaceAddress"
                          options={
                            this.props.addresses.data.map(item => {
                              return { label: item.name, value: item.id }
                            })} component={VirtualizedSelectFormComponent} required />
                      </div>
                      {this.props.selectedParkingSpaceArea && <div className="col-md-3 text-left">
                        <label>Area Selezionata</label>
                        <div style={{marginTop: 12}}>
                          <h4>{this.props.selectedParkingSpaceArea.name}</h4>
                        </div>
                      </div>}
                      {/* <div className="col-md-2 text-left">
                      <label>N° Civico</label>
                      <Field
                        component="input"
                        name="residenceCivicNumber"
                        type="text"
                        placeholder="N°"
                        className="resident-login"
                        required />
                    </div> */}
                    </div>
                  )}
                </div>
              </fiedset>}
              {/* Fine Informazioni Residente */}

              {/* Inizio Informazioni Lavoratore */}
              {isWorker(this.props.selectedCategories) &&
              <fiedset>
                <div className="titolo-categoria">
                  {this.props.selectedCategories.map((item, index) => <legend
                    key={item.id + '-' + index}
                    className="text-left">{item.label}</legend>)}
                </div>
                <div>
                  <div className="row">
                    <div className="col-md-6 text-left">
                      <label>Nome Azienda</label>
                      <Field
                        component="input"
                        name="companyName"
                        type="text"
                        placeholder="Nome Azienda..."
                        className="resident-login"
                        required />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <label>Seleziona Area di Lavoro</label>
                      <Field name="workAreaId" className="form-control" component="select" required>
                        <option value={''}>Seleziona Area</option>
                        {this.props.areas.map((item, index) =>
                          <option key={`${item.id}-${index}`} value={item.id}>{item.name}</option>)}
                      </Field>
                    </div>
                    <div className="col-md-4 text-left">
                      <label>Indirizzo di Lavoro</label>
                      <Field
                        component="input"
                        name="workAddress"
                        type="text"
                        placeholder="Piazza X"
                        className="resident-login"
                        required />
                    </div>
                    <div className="col-md-2 text-left">
                      <label>N° Civico</label>
                      <Field
                        component="input"
                        name="workCivicNumber"
                        type="text"
                        placeholder="N°"
                        className="resident-login"
                        required />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 text-left">
                      <label>Partita IVA</label>
                      <Field component="input" name="vatNumber" type="text" placeholder="0123456789" className="resident-login" required />
                    </div>
                  </div>
                </div>
              </fiedset>}

              {isWorkerPerson(this.props.selectedCategories) &&
              <fiedset>
                <div className="titolo-categoria">
                  {this.props.selectedCategories.map((item, index) => <legend
                    key={item.id + '-' + index}
                    className="text-left">{item.label}</legend>)}
                </div>
                <div>
                  <div className="row">
                    <div className="col-md-6 text-left">
                      <label>Nome Azienda</label>
                      <Field
                        component="input"
                        name="companyName"
                        type="text"
                        placeholder="Nome Organizzazione..."
                        className="resident-login"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-7 text-left">
                      <label>Sede Azienda/Residenza</label>
                      <Field
                        component="input"
                        type="text"
                        className="form-control"
                        name="workAddress"
                      />
                    </div>
                    <div className="col-md-2 text-left">
                      <label>N° Civico</label>
                      <Field
                        component="input"
                        name="workCivicNumber"
                        type="text"
                        placeholder="N°"
                        className="resident-login"
                      />
                    </div>
                  </div>

                  <div>
                    <div className="row">
                      <div className="col-md-6 text-left">
                        <label>Partita IVA</label>
                        <Field
                          component="input"
                          name="vatNumber"
                          type="text"
                          placeholder="0123456789"
                          className="resident-login"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </fiedset>}
              {/* Fine Informazioni Lavoratore/Titolare di Attività Economica */}
              {/* Fine Informazioni Titolare di Attività Economica */}

              {this.props.loading && <div className="well">Modifica Utente in Corso...</div> }

              {this.props.error && <div className="panel panel-danger">
                {this.props.error}
              </div>}

              {this.props.success && <div>
                <div className="row">
                  <div className="col-md-4 col-md-offset-4 ">
                    <div className="contrassegno">
                      <h4 className="contrassegno-h">Utente modificato correttamente!</h4>
                      <p>
                        <NavLink to={'/backoffice/users/' + this.props.user.id} className="btn btn-green">
                          Torna Al Profilo
                        </NavLink>
                      </p>
                    </div>
                  </div>
                </div>
              </div>}
              <p className="margin-btn-p">
                <button type="submit" className="btn btn-green">
                  Modifica Utente
                </button>
              </p>
            </div>
          </form>
        </div>
      </div>

      <div className="panel panel-default">
        <div className="panel-body">
          {this.state.deleteClicked && <div className="row">
            <div className="col-md-12 text-center" style={{marginBottom: 10}}>
              <h3>Attenzione! Questa operazione non è reversibile, assicurarsi che non ci siano abbonamenti o contrassegni attivi su questo utente prima di confermare l{"'"}eliminazione</h3>
            </div>
          </div>}
          <div className="row">
            <div className="col-md-12 text-center">
              {!this.state.deleteClicked &&
              <a onClick={() => this.setState({deleteClicked: true})} className="btn btn-delete">ELIMINA UTENTE</a>}
              {this.state.deleteClicked &&
              <a style={{marginRight: 20}} onClick={() => this.setState({deleteClicked: false})} className="btn btn-cancel">ANNULLA ELIMINAZIONE</a>}
              {this.state.deleteClicked &&
              <a onClick={this.props.onDeleteUser} className="btn btn-delete">CONFERMA ELIMINAZIONE UTENTE</a>}
            </div>
          </div>
        </div>
      </div>
    </div>)
  }
}

BackOfficeUserEditScreen = reduxForm({
  form: 'backofficeUserEdit',
  enableReinitialize: true
})(BackOfficeUserEditScreen)

export default connect(mapStateToProps, mapDispatchToProps)(BackOfficeUserEditScreen)



// WEBPACK FOOTER //
// ./src/screens/BackOfficeUserEditScreen.js